<template>
  <div>
    <span v-for="tag in activeTags" class="badge badge-secondary ml-1 px-2 py-1">
      {{ tag.name }}
      <a href="" class="text-decoration-none text-danger font-weight-bold ml-1" @click.prevent="removeTag(tag.id)">
        <span class="fas fa-times"></span>
      </a>
    </span>
    <select v-if="unselectedTags.length > 0" class="form-control form-control-sm ml-1" @change="addTag" :disabled="changingTags">
      <option value="">Add Tag</option>
      <option v-for="tag in unselectedTags" :value="tag.id" :key="tag.id">{{ tag.name }}</option>
    </select>
    <div v-if="changingTags" class="spinner-border spinner-border-sm" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Tags",
    props: {
      allTags: {
        type: Array,
        default: function () {
          return [];
        }
      },
      activeTags: {
        type: Array,
        default: function() {
          return [];
        }
      },
      incidentId: {
        type: Number,
        required: true,
      }
    },
    data() {
      return {
        changingTags: false
      }
    },
    computed: {
      unselectedTags() {
        const activeTagIds = this.activeTags.map(tag => tag.id);
        return this.allTags.filter(tag => !activeTagIds.includes(tag.id));
      }
    },
    methods: {
      async addTag(e) {
        this.changingTags = true;
        const tagId = e.target.value;
        const tags = await this.updateTags(tagId, "add");
        // reset select
        e.target.value = '';
        this.changingTags = false;

        this.$emit('update-tags', tags);
      },
      async removeTag(id) {
        this.changingTags = true;
        const tags = await this.updateTags(id, "delete");
        this.changingTags = false;
        this.$emit('update-tags', tags);
      },
      async updateTags(id, op) {
        const url = `${this.$config.baseUrl}/api/v2/incidents/${this.incidentId}?include=${this.$config.apiIncludes}`;
        let body = [
          {
            "path": "/tags",
            "op": op,
            "value": [id],
          }
        ];
        const res = await fetch(url, {
          method: "PATCH",
          body: JSON.stringify(body)
        });
        if (!res.ok) {
          alert('Something went wrong, please refresh the page and try again');
          return;
        }
        const data = (await res.json()).data;

        return data.tags;
      }
    }
  }
</script>

<style scoped>

</style>